function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#707070;}\n\t.st1{enable-background:new    ;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  className: "st1"
}, React.createElement("path", {
  id: "dev_1",
  fill: "#707070",
  d: "M131.9,89.1L50.4,119l81.5,29.9v24.1L23,131.6v-25.1L131.9,65V89.1z"
}), React.createElement("path", {
  id: "dev_2",
  fill: "#707070",
  d: "M217.9,4.9h26.5l-78,218.6h-26.5L217.9,4.9z"
}), React.createElement("path", {
  id: "dev_3",
  fill: "#707070",
  d: "M359,106.5v25.1l-108.9,41.5v-24.1l81.5-29.9l-81.5-29.9V65L359,106.5z"
}));

var SvgDevelopersIcon = function SvgDevelopersIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 382 228.3",
    style: {
      enableBackground: "new 0 0 382 228.3"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDevelopersIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/developers-icon.08cc8787.svg";
export { ForwardRef as ReactComponent };